import { render, staticRenderFns } from "./PagePortage.vue?vue&type=template&id=4c44a59f&"
import script from "./PagePortage.vue?vue&type=script&lang=js&"
export * from "./PagePortage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports